import * as React from "react";

import { Formik, FormikHelpers, FormikProps, FormikValues } from "formik";

import { Loader } from "components/elements";
import { PageContent, PageError, PageHeader } from "components/layout";

interface TiVoAppFormikProps<T> {
  header: string;
  loading?: boolean;
  error?: Error | null;
  onSubmit: (values: T, formikHelpers: FormikHelpers<T>) => Promise<void>;
  initialValues: T;
  validationSchema: object;
  children: (props: FormikProps<T>) => React.ReactNode;
}

export function TiVoAppFormik<T extends FormikValues>({
  header,
  loading,
  error,
  onSubmit,
  initialValues,
  validationSchema,
  children,
}: TiVoAppFormikProps<T>) {
  if (loading) {
    return <Loader />;
  }

  if (error) {
    return <PageError pageHeader={header} error={error} />;
  }

  return (
    <>
      <PageHeader>{header}</PageHeader>
      <PageContent>
        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          validationSchema={validationSchema}
          enableReinitialize
        >
          {children}
        </Formik>
      </PageContent>
    </>
  );
}
